import styled from 'styled-components';

import { Grid, colors } from '@dexma/ui-components';
import { headerHeight } from 'adapter/in/dashboards/pages/globalStyles';
import { alertHeight } from 'adapter/in/common/context/Alert';

type DashboardPageProps = {
    showAlert: boolean;
};

export default styled(Grid)<DashboardPageProps>`
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    height: 100%;
    background-color: ${colors.gray100};
    .layout {
        overflow: hidden;
        position: relative;
        height: ${(props) => (props.showAlert ? `calc(100% - ${alertHeight} - ${headerHeight})` : `calc(100% - ${headerHeight})`)};
    }
`;
